module.exports = __webpack_public_path__ + "static/media/visa-card.3ef9a260.png";